import { Component, Input } from '@angular/core'

import { BillingService } from '@shared/services/billing.service'

import { BillingQuantitiesFields, BillingPricingFields } from '@shared/models/billing.model'
import { PlatformSettingsService } from '@app/core/services/platfrom-settings.service'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[billingTableRow]',
  templateUrl: './billing-table-row.component.html',
  styleUrls: ['./billing-table-row.component.scss'],
  standalone: false,
})
export class BillingTableRowComponent {
  @Input() name: string
  @Input() status: string
  @Input() isEditable = false

  editMode = false
  isLoading = false

  private _quantity: number
  @Input()
  set quantity(value: number) {
    this._quantity = value
  }
  get quantity(): number {
    return <number>(this._quantity ?? this.billingService.billingQuantities[<string>BillingQuantitiesFields[this.name]])
  }

  get price(): number {
    return <number>this.billingService.billingPricing[<string>BillingPricingFields[this.name]] || 0
  }
  set price(value: number) {
    this.billingService.billingPricing[<string>BillingPricingFields[this.name]] = value
  }

  get clientCurrencySymbol(): string {
    return this.platformSettingsService.getClientCurrency()?.symbol
  }

  constructor(
    private readonly billingService: BillingService,
    private readonly platformSettingsService: PlatformSettingsService,
  ) {}

  savePrice(): void {
    this.isLoading = true

    this.billingService
      .patchBillingPricing(this.billingService.billingPricing.id, { [BillingPricingFields[this.name]]: this.price })
      .subscribe((): void => {
        this.isLoading = false
        this.editMode = false
      })
  }
}
